"use strict";

function findApp(obj) {
  if (obj) {
    if (obj.context && obj.context.app) {
      return obj.context.app;
    }

    if (obj.props && obj.props.app) {
      return obj.props.app;
    }
  }
}

module.exports = findApp;


//////////////////
// WEBPACK FOOTER
// ./node_modules/marty-lib/modules/core/findApp.js
// module id = 61b8
// module chunks = 88